import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../../services/auth.service';
import { ToastService } from '../../../../services/toast.service';
import { OutOfOfficeModal } from '../../../out-of-office-modal/out-of-office-modal';

@Component({
  selector: 'app-user-profile',
  imports: [OutOfOfficeModal],
  templateUrl: './user-profile.html',
  styleUrl: './user-profile.scss'
})
export class UserProfile implements OnInit {
  userData: any;
  isOutOfOfficeModalOpen: boolean = false;
  isSuperAdmin: boolean = false;

  constructor(private router: Router, private authService: AuthService, private toast: ToastService) {
    this.userData = JSON.parse(localStorage.getItem('user') || '{}');
  }

  ngOnInit(): void {
    if (window.location.pathname.includes('/admin')) {
      this.isSuperAdmin = true;
    }
  }

  openOutOfOfficeModal(): void {
    this.isOutOfOfficeModalOpen = true;
  }

  closeOutOfOfficeModal(): void {
    this.isOutOfOfficeModalOpen = false;
  }

  logout() {
    const selectedRole = localStorage.getItem('selectedRole');
    const role = selectedRole ? JSON.parse(selectedRole) : null;
    const role_id = role?.role_id || this.userData?.roles?.[0]?.id;
    const isSuperAdmin = localStorage.getItem('super_admin') === '/admin';

    const logoutObservable = isSuperAdmin ? this.authService.adminLogout(role_id) : this.authService.logout(role_id);
    logoutObservable.subscribe({
      next: () => this.redirectAfterLogout(isSuperAdmin),
      error: () => {
        this.authService.clearUser();
        this.redirectAfterLogout(isSuperAdmin);
      }
    });
  }
  private redirectAfterLogout(isSuperAdmin: boolean) {
    this.router.navigate([isSuperAdmin ? '/admin/login' : '/login']);
  }
}